module.exports = __webpack_public_path__ + "img/gedung.5c842407.jpeg";